<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div>
        <h5 class="mb-0 font-weight-bold">Test Management</h5>
        <p class="text-secondary text-sm mb-0">Test cases &amp; execution tracking</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <test-project-table />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <team-b-table />
      </div>
    </div>
  </div>
</template>

<script>
import TestProjectTable from "./components/TestProjectTable";
import TeamBTable from "./components/TeamBTable";

export default {
  name: "test-management",
  components: {
    TestProjectTable,
    TeamBTable,
  },
};
</script>
